import { DBFind, DBFindOne, ReduxInsert } from '@weblite/persist'
import { Pv } from '@weblite/ts-action/pv'
import { createStorage } from '../lib/storage'

const COLLECTION = 'pvs'
const [storage, pvsReducer] = createStorage<Pv>(COLLECTION)

const findByUser = (userId: string) =>
  DBFindOne(COLLECTION, userId, 'to') as Promise<Pv>

let loadedAll = false
async function dbGetAll() {
  if (loadedAll) return storage.getAll()

  const res = (await DBFind(COLLECTION)) as Pv[]
  ReduxInsert(COLLECTION, res)
  loadedAll = true
  return res
}

const pvsStorage = { ...storage, findByUser, dbGetAll }

export { pvsReducer, pvsStorage }
